import {StoreObj} from './store-obj';

export class EvaluateStoreRequest {
  store: StoreObj;
  text: string;
  expectedAnswer: string;

  constructor(store: StoreObj, text: string, expectedAnswer: string) {
    this.store = store;
    this.text = text;
    this.expectedAnswer = expectedAnswer;
  }
}
